import { Locale } from 'chaika-enums';
export const incuranceModule = {
    doctorMistake: {
        [Locale.Ru]: `Ошибка доктора`,
        [Locale.Am]: `Բժշկի սխալ`,
        [Locale.En]: `Doctor's mistake`,
        [Locale.Pt]: 'Erro do médico',
        [Locale.Ge]: `Doctor's mistake`,
    },
    referralCreatorMistake: {
        [Locale.Ru]: `Ошибка создавшего направление`,
        [Locale.Am]: `Ուղեգիրը ստեղծողի սխալ`,
        [Locale.En]: `Error of the referral creator`,
        [Locale.Pt]: 'Erro do criador do encaminhamento',
        [Locale.Ge]: `Error of the referral creator`,
    },
    patientWillPay: {
        [Locale.Ru]: `Заплатит пациент`,
        [Locale.Am]: `Կվճարի պացիենտը`,
        [Locale.En]: `The patient will pay`,
        [Locale.Pt]: 'O paciente pagará',
        [Locale.Ge]: `The patient will pay`,
    },
    officeWillPay: {
        [Locale.Ru]: `Заплатит офис`,
        [Locale.Am]: `Կվճարի գրասենյակը`,
        [Locale.En]: `The office will pay`,
        [Locale.Pt]: 'O consultório pagará',
        [Locale.Ge]: `The office will pay`,
    },
    headWillPay: {
        [Locale.Ru]: `Заплатит главный врач`,
        [Locale.Am]: `Կվճարի գլխավոր բժիշկը`,
        [Locale.En]: `The head physician will pay`,
        [Locale.Pt]: 'O médico-chefe pagará',
        [Locale.Ge]: `The head physician will pay`,
    },
    insurerMistake: {
        [Locale.Ru]: `Ошибка страховщика`,
        [Locale.Am]: `Ապահովագրողի սխալ`,
        [Locale.En]: `Insurer's mistake`,
        [Locale.Pt]: 'Erro da seguradora',
        [Locale.Ge]: `Insurer's mistake`,
    },
    underOtherProgram: {
        [Locale.Ru]: `Выставить по другой программе`,
        [Locale.Am]: `Դուրս գրել այլ ծրագրով`,
        [Locale.En]: `Exhibit under another program`,
        [Locale.Pt]: 'Emitir sob outro programa',
        [Locale.Ge]: `Exhibit under another program`,
    },
    reSubmit: {
        [Locale.Ru]: `Выставить повторно`,
        [Locale.Am]: `Դուրս գրել կրկին`,
        [Locale.En]: `Re-submit`,
        [Locale.Pt]: 'Reenviar',
        [Locale.Ge]: `Re-submit`,
    },
    alreadyTaken: {
        [Locale.Ru]: `Уже учтено`,
        [Locale.Am]: `Արդեն հաշվի է առնված`,
        [Locale.En]: `Already taken into account`,
        [Locale.Pt]: 'Já contabilizado',
        [Locale.Ge]: `Already taken into account`,
    },
    clinicWillPay: {
        [Locale.Ru]: `Заплатит клиника`,
        [Locale.Am]: `Կվճարի կլինիկան`,
        [Locale.En]: `The clinic will pay`,
        [Locale.Pt]: 'A clínica vai pagar',
        [Locale.Ge]: `The clinic will pay`,
    },
    practiceWillPay: {
        [Locale.Ru]: `Заплатит практика`,
        [Locale.Am]: `Կվճարի պրակտիկան`,
        [Locale.En]: `Practice will pay`,
        [Locale.Pt]: 'A prática pagará',
        [Locale.Ge]: `Practice will pay`,
    },
    act: {
        [Locale.Ru]: `Акт`,
        [Locale.Am]: `Ակտ`,
        [Locale.En]: `Act`,
        [Locale.Pt]: 'ato',
        [Locale.Ge]: `Act`,
    },
    actNumber: {
        [Locale.Ru]: `Номер акта`,
        [Locale.Am]: `Ակտի համար`,
        [Locale.En]: `Act number`,
        [Locale.Pt]: 'Número do ato',
        [Locale.Ge]: `act number`,
    },
    actDate: {
        [Locale.Ru]: `Дата акта`,
        [Locale.Am]: `Ակտի ամսաթիվ`,
        [Locale.En]: `Act date`,
        [Locale.Pt]: 'Data do ato',
        [Locale.Ge]: `Act date`,
    },
    insuredFullName: {
        [Locale.Ru]: `ФИО застрахованного`,
        [Locale.Am]: `Ապահովագրվածի անուն, ազգանուն, հայրանուն`,
        [Locale.En]: `Full name of the insured`,
        [Locale.Pt]: 'Nome completo do segurado',
        [Locale.Ge]: `Full name of the insured`,
    },
    serviceDate: {
        [Locale.Ru]: `Дата услуги`,
        [Locale.Am]: `Ծառայության ամսաթիվ`,
        [Locale.En]: `Service date`,
        [Locale.Pt]: 'Data do serviço',
        [Locale.Ge]: `Service date`,
    },
    withdrawalAmount: {
        [Locale.Ru]: `Сумма снятия`,
        [Locale.Am]: `Դուրսգրման գումար`,
        [Locale.En]: `Withdrawal amount`,
        [Locale.Pt]: 'Valor da retirada',
        [Locale.Ge]: `Withdrawal amount`,
    },
    ICComment: {
        [Locale.Ru]: `Комментарий СК`,
        [Locale.Am]: `Ապահովագրական ընկերության մեկնաբանություն`,
        [Locale.En]: `IC comment`,
        [Locale.Pt]: 'Comentário IC',
        [Locale.Ge]: `IC comment`,
    },
    rsInformation: {
        [Locale.Ru]: `Инфо о оказанной услуги`,
        [Locale.Am]: `Տեղեկություն մատուցված ծառայության մասին`,
        [Locale.En]: `Information about the rendered service`,
        [Locale.Pt]: 'Informações sobre o serviço prestado',
        [Locale.Ge]: `Information about the rendered service`,
    },
    rsRefInformation: {
        [Locale.Ru]: `Инфо о направлении для оказанной услуги`,
        [Locale.Am]: `Տեղեկություն մատուցված ծառայության ուղեգրի մասին`,
        [Locale.En]: `Information about the referral for the rendered service`,
        [Locale.Pt]: 'Informações sobre o encaminhamento para o serviço prestado',
        [Locale.Ge]: `Information about the referral for the rendered service`,
    },
    responsibility: {
        [Locale.Ru]: `Ответственность`,
        [Locale.Am]: `Պատասխանատվություն`,
        [Locale.En]: `Responsibility`,
        [Locale.Pt]: 'Responsabilidade',
        [Locale.Ge]: `Responsibility`,
    },
    finalAmount: {
        [Locale.Ru]: `Финальная сумма`,
        [Locale.Am]: `Վերջնական գումար`,
        [Locale.En]: `Final amount`,
        [Locale.Pt]: 'Montante final',
        [Locale.Ge]: `Final amount`,
    },
    processingDate: {
        [Locale.Ru]: `Дата обработки`,
        [Locale.Am]: `Մշակման ամսաթիվ`,
        [Locale.En]: `Date of processing`,
        [Locale.Pt]: 'Data de processamento',
        [Locale.Ge]: `Date of processing`,
    },
    createListProtest: {
        [Locale.Ru]: `Создание списка опротестования`,
        [Locale.Am]: `Բողոքարկման ցանկի ստեղծում`,
        [Locale.En]: `Creating a protest list`,
        [Locale.Pt]: 'Criando uma lista de protesto',
        [Locale.Ge]: `Creating a protest list`,
    },
    addList: {
        [Locale.Ru]: `Добавить список`,
        [Locale.Am]: `Ավելացնել ցանկ`,
        [Locale.En]: `Add list`,
        [Locale.Pt]: 'Adicionar lista',
        [Locale.Ge]: `Add list`,
    },
    toActList: {
        [Locale.Ru]: `К списку актов`,
        [Locale.Am]: `Դեպի ակտերի ցանկ`,
        [Locale.En]: `To act list`,
        [Locale.Pt]: 'Lista de atos',
        [Locale.Ge]: `To act list`,
    },
    editListProtest: {
        [Locale.Ru]: `Редактирование списка опротестования`,
        [Locale.Am]: `Բողոքարկման ցանկի խմբագրում`,
        [Locale.En]: `Editing a protest list`,
        [Locale.Pt]: 'Editando uma lista de protesto',
        [Locale.Ge]: `Editing a protest list`,
    },
    editProtest: {
        [Locale.Ru]: `Редактирование опротестования`,
        [Locale.Am]: `Բողոքարկման խմբագրում`,
        [Locale.En]: `Editing a protest`,
        [Locale.Pt]: 'Editando um protesto',
        [Locale.Ge]: `Editing a protest`,
    },
    dataLoadedSuccessfully: {
        [Locale.Ru]: `Данные успешно загружены`,
        [Locale.Am]: `Տվյալները հաջողությամբ բեռնվել են`,
        [Locale.En]: `Data loaded successfully`,
        [Locale.Pt]: 'Dados carregados com sucesso',
        [Locale.Ge]: `Data loaded successfully`,
    },
    withoutHeadline: {
        [Locale.Ru]: `Без строчки с заголовками`,
        [Locale.Am]: `Առանց վերնագրերի տողի`,
        [Locale.En]: `Without heading line`,
        [Locale.Pt]: 'Sem linha de título',
        [Locale.Ge]: `Without heading line`,
    },
    dateFormatIn: {
        [Locale.Ru]: `Дата в формате ДД.ММ.ГГГГ`,
        [Locale.Am]: `Ամսաթիվ ՕՕ.ԱԱ.ՏՏՏՏ ձևաչափով`,
        [Locale.En]: `Date in DD.MM.YYYY format`,
        [Locale.Pt]: 'Dados no formato DD.MM.AAAA',
        [Locale.Ge]: `Date in DD.MM.YYYY format`,
    },
    searchByActNumber: {
        [Locale.Ru]: `Поиск по номеру акта`,
        [Locale.Am]: `Որոնում ըստ ակտի համարի`,
        [Locale.En]: `Search by act number`,
        [Locale.Pt]: 'Pesquise por número do ato',
        [Locale.Ge]: `Search by act number`,
    },
    searchByPolicyNumber: {
        [Locale.Ru]: `Поиск по номеру полиса`,
        [Locale.Am]: `Որոնում ըստ պոլիսի համարի`,
        [Locale.En]: `Search by policy number`,
        [Locale.Pt]: 'Pesquise por número da apólice',
        [Locale.Ge]: `Search by policy number`,
    },
    choosePaymentMethod: {
        [Locale.Ru]: 'Выбрать способ оплаты',
        [Locale.Am]: 'Ընտրել վճարման եղանակը',
        [Locale.En]: 'Choose payment method',
        [Locale.Ge]: 'Choose payment method',
        [Locale.Pt]: 'Escolha o método de pagamento',
    }
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
